export default {
  /**
   * Tất cả
   */
  None: 0,

  /**
   * Hoạt động
   */
  Action: 1,

  /**
   * Hệ thống
   */
  System: 2,

  /**
   * Khuyến mại
   */
  Promotion: 3,

  /**
   * Đơn vị cấp dưới nhận biên bản kiểm tra dự toán 3 năm
   */
  AuditEstimateThreeYear: 4,
};
